<template>
  <router-link class="list-item" :to="to">
    <img src="../assets/icon-list.png" alt="" class="icon">
    <template v-if="currentUser.role==='user'">
      <span class="title">{{ title }}</span>
    </template>
    <template v-else>
      <span class="title">{{ companyName }}</span>
      <span class="month">{{ month.substring(0,7) }}</span>
    </template>
    <span class="gt">&gt;</span>
  </router-link>
</template>

<script>
  export default {
    name: "SheetItem",
    props: {
      month: {
        type: String,
        required: true
      },
      to: {
        type: String,
        required: true
      },
      companyName: {
        type: String,
        required: true
      }
    },
    computed: {
      title() {
        let arr = this.month.split('-');
        return `${arr[0]}年${arr[1]}月报表`;
      }
    }
  }
</script>

<style scoped>
  a {
    text-decoration: none;
  }

  .list-item {
    display: flex;
    align-items: center;
    height: 50px;
    border-bottom: 1px solid #ccc;
  }

  .list-item .icon {
    width: 19px;
    height: 19px;
  }

  .list-item .title {
    flex: 1 1 auto;
    color: #181818;
    margin: 0 12px;
    word-break: break-all;
  }

  .list-item .month {
    color: #999;
    margin: 0 2px;
    width: 60px;
    flex: 0 0 auto;
  }

  .list-item .gt {
    color: #C7C7CB;
    width: 12px;
    flex: 0 0 auto;
  }
</style>
